// extracted by mini-css-extract-plugin
export default {"Link":"UxmVl5F9"};